<template>
  <div>
    <!-- 信息维护 -->
    <!-- 头部 -->

    <Head />
    <!--  -->

    <div class="informationMaintenanceDetail">
      <!-- 面包屑 -->
      <div class="breadcrumb">
        <!-- 客户管理 -->
        <div class="item">
          {{ $t('message.customerManagement') }} /
        </div>
        <!--商品列表  -->
        <div class="item">
          {{ $t('message.productList') }} /
        </div>
        <!-- 查看 -->
        <div class="item">
          {{ $t('message.look') }}
        </div>
      </div>
      <!-- 详情 -->
      <div class="detail">
        <!--商品信息 -->
        <div class="productInformation-box">
          <!-- 商品信息 -->
          <div class="productInformation ">
            <div class="name">
              {{ $t('message.commodityInformation') }}
            </div>
            <div class="content">
              <div class="img">
                <el-image style="width: 160px;height: 160px;border-radius: 6px; margin-right: 12px;" :src="detail.pic"
                  :preview-src-list="[detail.pic]">
                </el-image>
                <!-- 编辑 -->
                <div class="redact">
                  <el-upload class="upload-demo" ref="upload" action="https://jsonplaceholder.typicode.com/posts/"
                    :before-upload="befoUpload" :show-file-list="false" :http-request="httpup">
                    <el-button type="text" slot="trigger">{{ $t('message.redact') }}</el-button>
                  </el-upload>
                </div>
              </div>
              <!-- 属性 -->
              <div class="attribute" v-if="detail.client_product_link">
                <div class="tag">
                  {{ detail.client_sku_code }}
                  <i class="el-icon-caret-right"></i>
                </div>
                <p v-for="(item, index) in detail.client_product_link[0].item_sku.detail" :key="index">
                  {{ item.key }} : {{ item.value }}
                </p>
              </div>
            </div>
          </div>
          <!-- 商品名称-->
          <div class="productName">
            <!-- 商品名称（中文） -->
            <div class="item">
              <div class="name">
                {{ $t('message.productNameChinese') }}
              </div>
              <el-input type="textarea" v-model="detail.goods_title_cn"
                @blur="updateGoodsTitle('goods_title_cn', detail.goods_title_cn)"></el-input>
            </div>
            <!-- 商品名称（日文） -->
            <div class="item">
              <div class="name">
                {{ $t('message.productNameJapanese') }}
              </div>
              <el-input type="textarea" v-model="detail.goods_title"
                @blur="updateGoodsTitle('goods_title', detail.goods_title)"></el-input>
            </div>
          </div>
          <!-- 商品管理备注 -->
          <div class="productManagementRemarks">
            <div class="item">
              <div class="name">
                {{ $t('message.productManagementRemarks') }}(日文)
                <!-- 下单自动跟随 -->
                <el-checkbox v-model="detail.remark_auto_order" class="fr" style="margin: 10px 24px 0 0"
                  @change="updateRemarkAutoOrder"> {{
                    $t('message.automaticallyFollowOrders') }}</el-checkbox>
              </div>
              <div class="content">
                <el-input type="textarea" v-model="detail.remark" @blur="updateRemark"></el-input>
              </div>
            </div>
            <!--  业务管理备注-->
            <div class="item">
              <div class="name">
                {{ $t('message.businessManagementRemarks') }}(中文)
                <!-- 下单自动跟随 -->
                <el-checkbox v-model="detail.y_remark_auto_order" class="fr" style="margin: 10px 0px 0 0"
                  @change="updateYRemarkAutoOrder"> {{
                    $t('message.automaticallyFollowOrders') }}</el-checkbox>
              </div>
              <div class="content">
                <el-input type="textarea" v-model="detail.y_remark" @blur="updateYRemark"></el-input>
              </div>
            </div>

          </div>

          <!--尺寸  单重-->
          <div class="productSize">
            <!-- 商品尺寸 -->
            <div class="name">
              {{ $t('message.productSize') }}(cm)
            </div>
            <div class="size">
              <el-input v-model="detail.length" @blur="updateSize"></el-input>*<el-input v-model="detail.width"
                @blur="updateSize"></el-input> * <el-input v-model="detail.height" @blur="updateSize"></el-input>
            </div>
            <!--  商品单重-->
            <div class="name">
              {{ $t('message.singleWeightOfProduct') }}(g)
            </div>
            <p> <el-input v-model="detail.weight" @change="updateWeight"></el-input></p>
          </div>
        </div>
        <div class="detail-body">
          <!-- 菜单  -->
          <div class="menu">
            <!-- 基础设置 -->
            <div class="item" v-for="(item, index) in menu" :key="index" :class="{ select: content == item.value }"
              @click="switchContent(item)">
              {{ item.name }}
            </div>
          </div>
          <!-- 内容 -->
          <div class="content-item">
            <component :is="content" :detail="detail" :ref="content" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Head from '@/components/header/detailHeader'
import basicSettings from './components/basicSettings'
import productLabelManagement from './components/productLabelManagement'
import optionSettings from './components/optionSettings'
import purchaseInformationMaintenance from './components/purchaseInformationMaintenance'
import productFileManagement from './components/productFileManagement'
import controlOverInvoices from './components/controlOverInvoices'
import materialManagement from './components/materialManagement'
import orderPlan from './components/orderPlan/index'
export default {
  components: {
    Head,
    basicSettings,
    optionSettings,
    productLabelManagement,
    purchaseInformationMaintenance,
    productFileManagement,
    controlOverInvoices,
    materialManagement,
    orderPlan
  },
  computed: {
    menu() {
      return [
        { name: this.$t('message.basicSettings'), value: 'basicSettings' },
        // 购买信息维护
        { name: this.$t('message.purchaseInformationMaintenance'), value: 'purchaseInformationMaintenance' },
        // 商品标签管理
        { name: this.$t('message.productLabelManagement'), value: 'productLabelManagement' },
        // option设置
        { name: this.$t('message.optionSettings'), value: 'optionSettings' },
        { name: this.$t('message.materialManagement'), value: 'materialManagement' },
        { name: this.$t('message.orderPlan'), value: 'orderPlan' },

        //  商品文件管理
        { name: this.$t('message.productFileManagement'), value: 'productFileManagement' },
        // 注意事项
        // { name: this.$t('message.mattersNeedingAttention'), value: ' mattersNeedingAttention ' },
        // 发票管理
        { name: this.$t('message.controlOverInvoices'), value: 'controlOverInvoices' },
      ]
    }
  },
  data() {
    return {
      val: '',
      checked: false,
      detail: {
        client_product_supply_type: []
      },
      content: 'basicSettings',
    };
  },
  created() {
    this.productList()
  },
  methods: {
    // 无需维护列表
    productList() {
      let datas = {
        sys_code: location.hash.split('=')[1].indexOf('#') !== -1 ? decodeURIComponent(location.hash.split('=')[1]) : this.$route.query.sys_code
      }
      this.$api.productManagementApi.productList(datas).then(res => {
        res.data.data.forEach(item => {
          item.remark_auto_order = item.remark_auto_order ? true : false
          item.y_remark_auto_order = item.y_remark_auto_order ? true : false
        })
        this.detail = res.data.data[0]
        this.switchContent({ value: this.content })
        console.log(this.detail);

      })
    },
    // 上传前
    befoUpload(file) {
      const isJPG =
        ["image/jpeg", "image/png", "image/jpg"].indexOf(file.type) != -1;
      if (!isJPG) {
        if (file.name.indexOf('HEIC') == -1) {
          this.$message.error("请上传图片");
          return isJPG;
        }
      }
    },
    // 上传
    async httpup(file) {
      let data = await this.createClient(file)
      let datas = {
        user_id: this.detail.user_id,
        sys_code: this.detail.sys_code,
        pic: data.data,
      }
      this.$api.productManagementApi.picUpdate(datas).then(res => {
        this.$message.success(res.msg)
        this.detail.pic = data.data
        this.$forceUpdate()
      })

    },
    //-商品标题设置
    updateGoodsTitle(type, value) {
      let datas = {
        user_id: this.detail.user_id,
        sys_code: this.detail.sys_code,
      }
      datas[type] = value
      this.$api.productManagementApi.updateGoodsTitle(datas)
    },
    //修改备注
    updateRemark() {
      let datas = {
        user_id: this.detail.user_id,
        sys_code_set: [this.detail.sys_code],
        remark: this.detail.remark,
      }

      this.$api.productManagementApi.updateRemark(datas)
    },
    // 备注是否下单自动跟随
    updateRemarkAutoOrder() {
      let datas = {
        user_id: this.detail.user_id,
        sys_code_set: [this.detail.sys_code],
        remark_auto_order: this.detail.remark_auto_order ? 1 : 0,
      }

      this.$api.productManagementApi.updateRemarkAutoOrder(datas)
    },
    //业务员备注设置
    updateYRemark() {
      let datas = {
        user_id: this.detail.user_id,
        sys_code_set: [this.detail.sys_code],
        y_remark: this.detail.y_remark,
      }

      this.$api.productManagementApi.updateYRemark(datas)
    },
    // 业务备注是否下单自动跟随
    updateYRemarkAutoOrder() {
      let datas = {
        user_id: this.detail.user_id,
        sys_code_set: [this.detail.sys_code],
        y_remark_auto_order: this.detail.y_remark_auto_order ? 1 : 0,
      }

      this.$api.productManagementApi.updateYRemarkAutoOrder(datas)
    },
    //长宽高设置
    updateSize() {
      let datas = {
        user_id: this.detail.user_id,
        sys_code: this.detail.sys_code,
        length: this.detail.length,
        width: this.detail.width,
        height: this.detail.height,
      }
      this.$api.productManagementApi.updateSize(datas)
    },
    //重量设置
    updateWeight() {
      let datas = {
        user_id: this.detail.user_id,
        sys_code: this.detail.sys_code,
        weight: this.detail.weight,
      }
      this.$api.productManagementApi.updateWeight(datas)
    },
    // 切换内容
    switchContent(item) {
      this.content = item.value
      this.$nextTick(() => {
        this.$refs[this.content].setData(this.detail)
        this.$forceUpdate()
      })
    },
  }
}
</script>
<style lang='scss' scoped>
.informationMaintenanceDetail {
  min-width: 1910px;

  .breadcrumb {
    margin: 24px 30px;
    display: flex;
    height: 52px;
    background: #F8F8F8;
    border-radius: 8px;
    padding-left: 23px;

    .item {
      font-size: 14px;
      color: #666666;
      margin-right: 9px;
      line-height: 52px;
    }
  }

  .detail {
    margin: 24px 30px;
    padding: 24px;
    background: #F8F8F8;
    border-radius: 6px;

    .content {
      border-right: 1px solid #DFDFDF;
      padding-right: 45px;
      display: flex;
    }

    .name {
      font-weight: bold;
      font-size: 18px;
      color: #333333;
      margin-bottom: 18px;
    }

    /deep/.el-textarea__inner {
      width: 220px;
      height: 160px;
      resize: none;
    }


    .img {
      position: relative;

      &:hover {
        .redact {
          display: block;
        }
      }

      .redact {
        position: absolute;
        top: 0;
        right: 20px;
        display: none;
      }
    }

    .productInformation-box {
      display: flex;

      .attribute {
        width: 215px;

        .tag {
          width: 190px;
          height: 36px;
          background: #FFEEEE;
          border-radius: 4px;
          position: relative;
          color: #B4272B;
          padding-left: 10px;
          line-height: 36px;
          margin-bottom: 24px;

          .el-icon-caret-right {
            font-size: 57px;
            position: absolute;
            top: -10px;
            right: -35px;
            color: #FFEEEE;

          }
        }
      }

    }

    .productName {
      display: flex;
      padding-left: 24px;

      .item {
        margin-right: 24px;

        &:nth-last-child(1) {
          margin: 0;
        }
      }
    }

    .productManagementRemarks {
      display: flex;

      .item {
        &:nth-child(1) {
          .content {
            margin-left: 24px;
            padding-left: 24px;
            border-left: 1px solid #DFDFDF;
            border-right: 0;
          }
        }

        &:nth-last-child(1) {
          .content {
            border-left: 0px solid #DFDFDF;
          }

          .name {
            margin-left: 0px;
          }
        }
      }

      .name {
        margin-left: 20px;
      }


    }

    .productSize {
      margin-left: 45px;

      .size {
        display: flex;
        line-height: 40px;
        margin-bottom: 45px;

        /deep/.el-input__inner {
          padding: 0;
          text-align: center;
        }
      }
    }
  }

  .detail-body {
    margin-top: 24px;
    border: 1px solid #DFDFDF;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 24px;

    .menu {
      display: flex;
      border-bottom: 1px solid #DFDFDF;

      .item {
        margin-right: 36px;
        padding-bottom: 12px;
        border-bottom: 4px solid transparent;
        font-size: 18px;
        color: #333333;
        cursor: pointer;
      }

      .select {
        border-color: #B4272B;
        font-weight: bold;
        font-size: 18px;

      }
    }

    .content-item {
      margin-top: 24px;
    }
  }
}
</style>
